import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Options element, used to hold up to 4 iconbutton elements
 *
 * @slot 1 - the first slot
 * @slot 2 - the second slot
 * @slot 3 - the third slot
 * @slot 4 - the fourth slot
 */
let SDBContentOptions = class SDBContentOptions extends LitElement {
    render() {
        return html `
            <slot name="1" class="contentOptionsIcon"></slot>
            <slot name="2" class="contentOptionsIcon"></slot>
            <slot name="3" class="contentOptionsIcon"></slot>
            <slot name="4" class="contentOptionsIcon"></slot>
        `;
    }
};
SDBContentOptions.styles = [
    elements,
    css `
            :host {
                display: grid;
                grid-auto-columns: fit-content;
                grid-auto-flow: column;
                justify-items: right;
            }

            :host .contentOptionsIcon {
                justify-content: center;
                align-content: center;
            }

            /* -------------------------------
    MOBILE LAYOUT = SAME AS LAYOUT-100
    ---------------------------------- */

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    display: block;
                    text-align: right;
                    padding: 0;
                }
            }
        `,
];
SDBContentOptions = __decorate([
    customElement('sdb-content-options')
], SDBContentOptions);
export { SDBContentOptions };
//# sourceMappingURL=sdb-content-options.js.map